<template>
  <div style="width: 100%;">
    <template v-if="!loading">
      <div class="col-12 activity-log-container">
        <b-row class="remove-default-row-margin">
          <div class="col-2"><b>{{ $t('date') }}</b></div>
          <div class="col-2" v-if="isInternal"><b>{{ $t('loginId') }}</b></div>
          <div class="col-8"><b>{{ $t('activity') }}</b></div>
        </b-row>
        <template v-for="activityLogItem in activityDetails">
          <b-row :key="activityLogItem.AuditId" class="remove-default-row-margin">
            <div class="col-2">{{ getReadableDate(activityLogItem.CreatedDate) }}</div>
            <div class="col-2" v-if="isInternal">{{ `${activityLogItem.UserLogin ? activityLogItem.UserLogin : ''}` }}</div>
            <div class="col-8">
              <b>{{ `${activityLogItem.Action} ${activityLogItem.Quantity || ''},`}}</b>
              {{ `${hostIdType ? `Host ID type: ${hostIdType}` : '' }` }}
              {{ `${activityLogItem.HostID ? `, Host ID: ${activityLogItem.HostID}` : '' }` }}
            </div>
          </b-row>
        </template>
        <b-row class="remove-default-row-margin">
          <div class="col-2">{{ getReadableDate(purchaseDate) }}</div>
          <div class="col-2" v-if="isInternal"></div>
          <div class="col-8">Purchased</div>
        </b-row>
      </div>
    </template>
    <template v-else>
      <loading customStyle="padding-top: 0;" />
    </template>
  </div>
</template>

<script>
  import moment from 'moment'

  import Loading from './Loading'

  export default {
    name: 'ActivityLog',
    components: {
      'loading': Loading
    },
    data () {
      return {
        loading: false,
        activityDetails: [],
        isInternal: window.location.host.includes('citrite.net')
      }
    },
    props: {
      hostIdType: {
        type: String,
        required: true
      },
      licenseId: {
        type: String,
        required: true
      },
      purchaseDate: {
        type: String,
        required: true
      }
    },
    mounted () {
      this.loading = true
      let isInternal = window.location.host.includes('citrite.net')
      let activityLogUrl = this.UrlBuilder.licenseDetailActivityLogUrl(
        this.$store.getters.person.customerId,
        this.licenseId
      )
      activityLogUrl = isInternal ? `${activityLogUrl}/true` : `${activityLogUrl}/false`
      this.bottle.get(activityLogUrl)
        .then(({ data }) => {
          this.activityDetails = data.activityDetails || []
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.loggly.log({
            errorMessage: `Failed to fetch activity log for ${this.licenseId}`,
            errorObject: error,
            errorStack: error.stack
          })
        })
    },
    methods: {
      getReadableDate (date) {
        let locale = this.$store.getters.person.preferences.locale || 'en-US'
        const formats = {
          'zh-CN': 'YYYY/MM/DD',
          'zh-TW': 'YYYY/MM/DD',
          'jp-JP': 'YYYY/MM/DD',
          'ko-KR': 'YYYY/MM/DD',
          'en-US': 'DD/MM/YYYY'
        }
        locale = Object.keys(formats).includes(locale) ? locale : 'en-US'
        const temp = moment(date).format(formats[locale])
        return (temp === '01/01/0001') || (temp === '0001/01/01') ? this.$t('notApplicable') : temp
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ActivityLog.vue